// src/api/config.js
const isDevelopment = process.env.NODE_ENV === 'development'

// ========== 环境配置 ==========
export const ENV_CONFIG = {
  isDev: isDevelopment,
  apiPrefix: isDevelopment ? '/dev-api' : '/prod-api',
  adminPrefix: isDevelopment ? '/dev-api' : '/admin'
}

// ========== Token配置 ==========
export const TOKEN_CONFIG = {
  // 前端专用Token（AICS接口）
  AICS_TOKEN: 'FRONTEND-2026-SECRET',
  // JWT Token key
  JWT_TOKEN_KEY: 'accessToken',
  REFRESH_TOKEN_KEY: 'refreshToken'
}

// ========== URL配置 ==========
export const URL_CONFIG = {
  // 基础URL
  baseApiUrl: isDevelopment ? 'http://localhost:8081/dev-api' : '/prod-api',
  authApiUrl: isDevelopment ? 'http://192.168.1.105:9000' : '/prod-api/auth-server',
    ssoApiUrl: isDevelopment ? 'http://192.168.1.105:9001' : '/prod-api/core-api',
  adminApiUrl: isDevelopment ? 'http://localhost:8180/dev-api' : '/api/admin',
  wsUrl: isDevelopment ? 'ws://localhost:8181/ws' : 'ws://www.bj-sunrise.net/ws'
}

// ========== 接口白名单 ==========
export const WHITE_LIST = {
  auth: ['/auth/login', '/auth/register', '/auth/captcha', '/auth/refresh'],
  aics: ['/public/stream-chat-endpoint']  // WebSocket等
}